class DescriptionReadMore extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.js-read-more-btn');
    if (!this.btn) return;

    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  /**
   * Handles click on the Read More button by finding the first accordion
   * in .product-details__block, opening it, and smoothly scrolling to it.
   * @param {MouseEvent} evt
   */
  handleClick(evt) {
    evt.preventDefault();

    // Locate the first accordion disclosure or details element within .product-details__block
    const detailsDisclosure = document.querySelector('.product-details__block details-disclosure');
    const details = document.querySelector('.product-details__block details');
    const tabBtn = document.querySelector('.product-details__block .tablist__tab');
    const genericBlock = document.querySelector('.product-details__block');

    let elementToScrollTo = null;

    if (detailsDisclosure) {
      const detailsEl = detailsDisclosure.querySelector('details') || detailsDisclosure;
      if (!detailsEl.open) {
        if (typeof detailsDisclosure.open === 'function') {
          detailsDisclosure.open();
        } else {
          const summary = detailsDisclosure.querySelector('summary');
          if (summary) {
            summary.click();
          } else {
            detailsEl.open = true;
          }
        }
      }

      const summary = detailsDisclosure.querySelector('summary');
      if (summary) {
        summary.focus({ preventScroll: true });
      }
      elementToScrollTo = summary || detailsDisclosure;
    } else if (details) {
      if (!details.open) {
        const summary = details.querySelector('summary');
        if (summary) {
          summary.click();
        } else {
          details.open = true;
        }
      }

      const summary = details.querySelector('summary');
      if (summary) {
        summary.focus({ preventScroll: true });
      }
      elementToScrollTo = summary || details;
    } else if (tabBtn) {
      tabBtn.click();
      tabBtn.focus({ preventScroll: true });
      elementToScrollTo = tabBtn;
    } else if (genericBlock) {
      elementToScrollTo = genericBlock;
    }

    if (elementToScrollTo) {
      let headerHeight = 0;
      const stickyHeader = document.querySelector('store-header[data-is-sticky="true"]');
      if (stickyHeader) {
        headerHeight = Number.parseInt(
          getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height')
            .replace('px', ''),
          10
        ) || 0;
      }

      const elementTop = elementToScrollTo.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      const offsetPosition = Math.max(0, elementTop - headerHeight - 20);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}

customElements.define('description-read-more', DescriptionReadMore);
